import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type {
	ClientFinancialPlanExpenseNameEnum,
	ClientFinancialPlanExpenseTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	type: ClientFinancialPlanExpenseTypeEnum | null;
	availableNames: ClientFinancialPlanExpenseNameEnum[];
	onSelect: (name: ClientFinancialPlanExpenseNameEnum) => void;
	onClose: () => void;
};

export const SubcategoryPickerDrawer: FC<Props> = ({
	type,
	availableNames,
	onSelect,
	onClose,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const title = type
		? `${t(Resources.Finances.SubcategoryPicker.title)} - ${t(Resources.Finances.Expenses.Types[type].title)}`
		: "";

	return (
		<MyPlannDrawer open={type !== null} onClose={onClose} title={title}>
			<Stack pb={theme.spacingTokens.lg}>
				{availableNames.length === 0 ? (
					<Typography
						variant="body2"
						textAlign="center"
						px={theme.spacingTokens.lg}
						py={theme.spacingTokens.section}
					>
						{t(Resources.Finances.SubcategoryPicker.allAdded)}
					</Typography>
				) : (
					availableNames.map((name, index) => (
						<ListRow
							key={name}
							title={t(Resources.Finances.Expenses.Names[name])}
							showChevron={false}
							isLast={index === availableNames.length - 1}
							onClick={() => onSelect(name)}
						/>
					))
				)}
			</Stack>
		</MyPlannDrawer>
	);
};
